export default __webpack_public_path__ + "static/media/wot_lanfear.1d21134a.jpg";